import { ELanguage } from './types'

export function buildLoginUrl(
    baseUrl: string,
    langCode: ELanguage,
    redirectTo?: string
) {
    return `${baseUrl}/${langCode === ELanguage.EN ? 'login' : 'dang-nhap'}${
        redirectTo
            ? `?type=login&redirectURL=${encodeURIComponent(redirectTo)}`
            : ''
    }`
}
